import { z } from "zod";
// The session cookie names, shared so the web's developer tools can name the cookie a
// copied request needs. __Host- demands Secure, which a plain-http local server cannot set.
export const SESSION_COOKIE = "__Host-v5_session";
export const LOCAL_SESSION_COOKIE = "v5_session";
// One adult owner account per site per signed-in identity. The role is the account's:
// platform_admin comes only from the verified PLATFORM_ADMIN_EMAILS allow-list.
export const AccountRoleSchema = z.enum(["owner", "platform_admin"]);
// Server-owned admin capabilities, static: platform_admin holds every one, owner none.
// The bootstrap copy is presentation only; every admin procedure re-authorizes per call.
export const ADMIN_CAPABILITIES = [
    "admin.overview.read",
    "admin.accounts.read",
    "admin.accounts.write",
    "admin.subscriptions.read",
    "admin.subscriptions.write",
    "admin.content.read",
    "admin.content.write",
    "admin.runs.read",
    "admin.audit.read",
    "admin.operations.read",
    "admin.costing.read",
];
export const AdminCapabilitySchema = z.enum(ADMIN_CAPABILITIES);
//# sourceMappingURL=identity.js.map